<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="deviceId" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="IMEI" v-model="imei" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-select v-model="cmdType" placeholder="指令类型" clearable style="width: 100%">
          <el-option label="设备重启" value="REBOOT"></el-option>
          <el-option label="恢复出厂设置" value="RESET_FACTORY"></el-option>
          <el-option label="获取GPS定位" value="GET_GPS"></el-option>
          <el-option label="设置上传间隔" value="SET_UPLOAD_INTERVAL"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
    </el-row>
    <el-table
      :data="data"
      border
      row-key="id"
      stripe
      style="width: 100%"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="device_id" label="设备编号">
      </el-table-column>
      <el-table-column prop="imei" label="IMEI" >
      </el-table-column>
      <el-table-column prop="cmdType" label="设备重启" >
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="handleClick(scope.row,'restartDevice')">
            下发
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="resetFactory" label="恢复出厂设置" >
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="handleClick(scope.row,'factoryReset')">
            下发
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="getGps" label="获取GPS定位" >
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="handleClick(scope.row,'getGpsLocation')">
            下发
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>
  
  <script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      deviceId: "",
      imei: "",
      cmdType: "",
      data: [],
      env: this.getEnv(),
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
   async created() {
    if (this.$route.params.id) {
      this.deviceId = this.$route.params.id !== ':id' ? this.$route.params.id : '';
      this.tableHeight = document.documentElement.clientHeight - 200 + "px";
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.relevancePagin.pageNum = val;
    },
    handleClick(row,type){
      // 处理点击事件，例如发送请求
      console.log('点击了下发按钮', row,type);
      const params = {
        deviceId: row.device_id
      };


      this.$http
        .post(`${this.env}/manage/carDeviceManage/${type}`, params)
        .then((results) => {
          console.log(results);
          if (results["data"]["code"] === 0) {
            this.$message({
              message: "下发成功",
              type: "success",
            });
          } else {
            this.$message({
              message: results["data"]["message"],
              type: "error",
            });
          }
        });
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
        topicType: "S/SET",
      };
      if (this.deviceId.trim() != "") {
        params.deviceId = this.deviceId;
      }
      if (this.imei.trim() != "") {
        params.imei = this.imei;
      }
      if (this.cmdType) {
        params.cmdType = this.cmdType;
      }
      this.$http
        .post(`${this.env}/manage/serviceTopicDataDownload/list`, params)
        .then((results) => {
          const records = results["data"]["data"]["records"];
          // 解析 json_data 字段
          this.data = records.map(item => {
            let jsonData = {};
            try {
              jsonData = JSON.parse(item.json_data || '{}');
            } catch (e) {
              console.error('解析 json_data 失败:', e);
            }
            // 根据 cmd_data 映射指令类型描述
            const cmdTypeMap = {
              'REBOOT': '设备重启',
              'RESET_FACTORY': '恢复出厂设置',
              'GET_GPS': '获取GPS定位',
              'SET_UPLOAD_INTERVAL': '设置上传间隔',
            };
            return {
              ...item,
              paramId: jsonData.paramId || '',
              paramKey: jsonData.paramKey || '',
              paramValue: jsonData.paramValue || '',
              applyTime: jsonData.applyTime || '',
              rebootRequired: jsonData.rebootRequired,
              description: jsonData.description || '',
              downTime: item.down_time || '',
              cmdData: item.cmd_data || '',
              cmdTypeDesc: cmdTypeMap[item.cmd_data] || item.cmd_data || '',
            };
          });
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
    getEnv() {
      if (location.host == "localhost:8080") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "iotmanage.baitengfa.com") {
        return "https://iotmanage.baitengfa.com";
      }
    },
    renderheader(h, { column }) {
      return h("span", {}, [
        h("span", {}, column.label.split("/")[0]),
        h("br"),
        h("span", {}, column.label.split("/")[1]),
        h("br"),
        h("span", {}, column.label.split("/")[2]),
        h("br"),
        h("span", {}, column.label.split("/")[3]),
      ]);
    },
  },
  components: { Pagination },
};
</script>
  
  <style scoped>
.tab {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
</style>